export const ORDER_STATUS = [
   {id: 2, title: 'Đang xử lý', status: 1},
   {id: 2, title: 'Đang vận chuyển', status: 2},
   {id: 2, title: 'Đang vận chuyển', status: 3},
   {id: 2, title: 'Không hoàn thành', status: 5},
   {id: 4, title: 'Hoàn thành', status: 4},
   {id: 8, title: 'Không hoàn thành', status: 6},
   {id: 8, title: 'Hủy đơn hàng', status: 7},
   {id: 8, title: 'Bán tại cửa hàng', status: 8},
   {id: 9, title: 'Hủy đơn hàng', status: 15},
   {id: 10, title: 'Đang vận chuyển', status: 17},
   {id: 11, title: 'Hoàn thành', status: 19},
   {id: 12, title: 'Hoàn thành', status: 20},
   {id: 13, title: 'Chờ xử lý', status: 21},
   {id: 14, title: 'Đang vận chuyển', status: 22},
   {id: 15, title: 'Đang vận chuyển', status: 23},
]

export const productExample = [
   {
      "id": "194",
      "type": "1",
      "title": "SP của ai",
      "image": "https://dtp-book-api.ryucms.com/uploads/products/images/1711444078_1c35932373c74237ecfc.jpg",
      "short_description": "",
      "status": "enable",
      "quantity": "10000",
      "price": "111000",
      "discount": "90",
      "discount_started_at": "2024-04-03 00:00:00",
      "discount_ended_at": "2024-05-31 00:00:00",
      "ordering": "1",
      "ordering_type": "2"
   },
   {
      "id": "104",
      "type": "1",
      "title": "Tiếng Anh 1 i-Learn Smart Start - Trọn bộ (sách học sinh, sách bài tập, vở tập viết)",
      "image": "https://dtp-book-api.ryucms.com/uploads/products/images/1709778363_8ade37cadb7dbeb42dc2.jpg",
      "short_description": "i-Learn Smart Start là bộ giáo trình tiếng Anh gồm 5 cấp độ dành cho học sinh Tiểu học tại Việt Nam. Giáo trình được nghiên cứu và biên soạn bởi đội ngũ các tác giả quốc tế kết hợp với đội ngũ giảng viên của Trường Đại học Sư phạm TP. Hồ Chí Minh, các chu",
      "status": "enable",
      "quantity": "100",
      "price": "168000",
      "discount": "15",
      "discount_started_at": "2024-05-01 00:00:00",
      "discount_ended_at": "2024-05-01 00:00:00",
      "ordering": "1",
      "ordering_type": "2"
   },
   {
      "id": "178",
      "type": "1",
      "title": "i-Learn Smart Start 12A",
      "image": "https://dtp-book-api.ryucms.com/uploads/products/images/1705652761_21b46f306bfdf7401b39.jpg",
      "short_description": "Mô tả ngắn sản phẩm",
      "status": "enable",
      "quantity": "10000",
      "price": "120000",
      "discount": "100",
      "discount_started_at": "2024-01-19 00:00:00",
      "discount_ended_at": "2024-01-31 00:00:00",
      "ordering": "1",
      "ordering_type": "2"
   },
   {
      "id": "93",
      "type": "1",
      "title": "i-Learn Smart Start Grade 3",
      "image": "https://zapi.dtpsoft.vn/uploads/products/images/1699000705_a862bd7897a01b1c903e.jpg",
      "short_description": "i-Learn Smart Start là bộ giáo trình tiếng Anh gồm 5 cấp độ dành cho học sinh Tiểu học tại Việt Nam. Giáo trình được nghiên cứu và biên soạn bởi đội ngũ các tác giả quốc tế kết hợp với đội ngũ giảng viên của Trường Đại học Sư phạm TP. Hồ Chí Minh, các chu",
      "status": "enable",
      "quantity": "1",
      "price": "105000",
      "discount": "0",
      "discount_started_at": null,
      "discount_ended_at": null,
      "ordering": "1",
      "ordering_type": "2"
   },
   {
      "id": "103",
      "type": "1",
      "title": "i-Learn Smart Start 4B",
      "image": "https://zapi.dtpsoft.vn/uploads/products/images/1699000498_1729cd3b83b828b2de10.jpg",
      "short_description": "i-Learn Smart Start là bộ giáo trình tiếng Anh gồm 5 cấp độ dành cho học sinh Tiểu học tại Việt Nam. Giáo trình được nghiên cứu và biên soạn bởi đội ngũ các tác giả quốc tế kết hợp với đội ngũ giảng viên của Trường Đại học Sư phạm TP. Hồ Chí Minh, các chu",
      "status": "enable",
      "quantity": "100",
      "price": "134000",
      "discount": "0",
      "discount_started_at": null,
      "discount_ended_at": null,
      "ordering": "1",
      "ordering_type": "2"
   },
   {
      "id": "102",
      "type": "1",
      "title": "i-Learn Smart Start 4A",
      "image": "https://zapi.dtpsoft.vn/uploads/products/images/1699000512_6103d0f83733d56de2e8.jpg",
      "short_description": "i-Learn Smart Start là bộ giáo trình tiếng Anh gồm 5 cấp độ dành cho học sinh Tiểu học tại Việt Nam. Giáo trình được nghiên cứu và biên soạn bởi đội ngũ các tác giả quốc tế kết hợp với đội ngũ giảng viên của Trường Đại học Sư phạm TP. Hồ Chí Minh, các chu",
      "status": "enable",
      "quantity": "1",
      "price": "134000",
      "discount": "0",
      "discount_started_at": null,
      "discount_ended_at": null,
      "ordering": "2",
      "ordering_type": "2"
   },
   {
      "id": "100",
      "type": "1",
      "title": "i-Learn Smart Start 3A",
      "image": "https://zapi.dtpsoft.vn/uploads/products/images/1699000545_4b1266509e1c1b28b7bb.jpg",
      "short_description": "i-Learn Smart Start là bộ giáo trình tiếng Anh gồm 5 cấp độ dành cho học sinh Tiểu học tại Việt Nam. Giáo trình được nghiên cứu và biên soạn bởi đội ngũ các tác giả quốc tế kết hợp với đội ngũ giảng viên của Trường Đại học Sư phạm TP. Hồ Chí Minh, các chu",
      "status": "enable",
      "quantity": "20",
      "price": "134000",
      "discount": "10",
      "discount_started_at": "2024-04-04 00:00:00",
      "discount_ended_at": null,
      "ordering": "3",
      "ordering_type": "2"
   },
   {
      "id": "101",
      "type": "1",
      "title": "i-Learn Smart Start 3B",
      "image": "https://zapi.dtpsoft.vn/uploads/products/images/1699000527_dfa5ff0b186c6095fae0.jpg",
      "short_description": "i-Learn Smart Start là bộ giáo trình tiếng Anh gồm 5 cấp độ dành cho học sinh Tiểu học tại Việt Nam. Giáo trình được nghiên cứu và biên soạn bởi đội ngũ các tác giả quốc tế kết hợp với đội ngũ giảng viên của Trường Đại học Sư phạm TP. Hồ Chí Minh, các chu",
      "status": "enable",
      "quantity": "1",
      "price": "134000",
      "discount": "10",
      "discount_started_at": "2024-04-03 00:00:00",
      "discount_ended_at": "2024-05-31 00:00:00",
      "ordering": "3",
      "ordering_type": "2"
   },
   {
      "id": "193",
      "type": "1",
      "title": "Tiếng Anh 8",
      "image": null,
      "short_description": "",
      "status": "enable",
      "quantity": "1",
      "price": "150000",
      "discount": "10",
      "discount_started_at": "2024-04-04 00:00:00",
      "discount_ended_at": "2024-04-05 00:00:00",
      "ordering": "4",
      "ordering_type": "2"
   },
   {
      "id": "99",
      "type": "1",
      "title": "i-Learn Smart Start 2B",
      "image": "https://zapi.dtpsoft.vn/uploads/products/images/1699000561_fa9800f41ce0a19abe7b.jpg",
      "short_description": "i-Learn Smart Start là bộ giáo trình tiếng Anh gồm 5 cấp độ dành cho học sinh Tiểu học tại Việt Nam. Giáo trình được nghiên cứu và biên soạn bởi đội ngũ các tác giả quốc tế kết hợp với đội ngũ giảng viên của Trường Đại học Sư phạm TP. Hồ Chí Minh, các chu",
      "status": "enable",
      "quantity": "1",
      "price": "134000",
      "discount": "0",
      "discount_started_at": null,
      "discount_ended_at": null,
      "ordering": "4",
      "ordering_type": "2"
   }
]